module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/en-关于盛泰banner.ea717781.png";